import { Injectable } from '@angular/core';
import { AccessCardControlReportRegistryItemInterface } from '@zaoblako/shared/modules/pacs/dtos/access-card-control-report/access-card-control-report-registry-item.dto';
import { AccessCardControlReportRegistryQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/access-card-control-report/access-card-control-report-registry-query.dto';
import { AccessCardControlReportStatItemInterface } from '@zaoblako/shared/modules/pacs/dtos/access-card-control-report/access-card-control-report-stat-item.dto';
import { AccessCardControlReportStatQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/access-card-control-report/access-card-control-report-stat-query.dto';
import type { ComingGoingReportQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/coming-going-report/coming-going-report-query.dto';
import type { ComingGoingReportPageInterface } from '@zaoblako/shared/modules/pacs/dtos/coming-going-report/coming-going-report-page.dto';

import { EquipmentLogPageInterface } from '@zaoblako/shared/modules/pacs/dtos/report/equipment-log-page.dto';
import { EquipmentLogQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/report/equipment-log-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ControlReportService extends BaseService {
  protected baseUrl = '/pacs/base/report';

  public eventReport(queryParams: EquipmentLogQueryInterface): Observable<EquipmentLogPageInterface> {
    return this.http.get<EquipmentLogPageInterface>(`${this.baseUrl}/events`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public comingGoingReport(queryParams: ComingGoingReportQueryInterface): Observable<ComingGoingReportPageInterface> {
    return this.http.get<ComingGoingReportPageInterface>(`${this.baseUrl}/coming-going`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getRegistry(
    queryParams: AccessCardControlReportRegistryQueryInterface
  ): Observable<AccessCardControlReportRegistryItemInterface[]> {
    return this.http.get<AccessCardControlReportRegistryItemInterface[]>(
      `${this.baseUrl}/access-card-control/registry`,
      {
        params: this.objectToHttpParams(queryParams)
      }
    );
  }

  public getStatistics(
    queryParams: AccessCardControlReportStatQueryInterface
  ): Observable<AccessCardControlReportStatItemInterface[]> {
    return this.http.get<AccessCardControlReportStatItemInterface[]>(`${this.baseUrl}/access-card-control/stat`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
